import axios from 'axios';

export default class ProductService {
    addToWishlist(product_id) {
        const headers = {
            headers: {
                'Authorization': `Bearer ${localStorage.token}`
            }
        };
        return axios.post(`/api/wishlist`, {product_id}, headers);
    }

    removeToWishlist(product_id) {
        const headers = {
            headers: {
                'Authorization': `Bearer ${localStorage.token}`
            }
        };
        return axios.post(`/api/wishlist/remove`, {product_id}, headers);
    }

    doGetFotwProducts(params) {
        if (!params.perPage) params.perPage = '';
        if (!params.categories) params.categories = '';
        if (!params.page) params.page = 1;
        if (!params.sort) params.sort = '';
        if (!params.term) params.term = '';
        if (!params.excludes) params.excludes = '';
        if (!params.fotw) params.fotw = "";
        
        const token = localStorage.token ? localStorage.token : '';
        var url = `/api/products?perPage=3&categories=${params.categories}&page=${params.page}&sort=${params.sort}&title=${params.term}&token=${token}&excludes=${params.excludes}&fotw=${params.fotw}`;
		url+="&language="+language;

        return axios.get(url);
    }

    doGetProducts(params) {
        if (!params.perPage) params.perPage = '';
        if (!params.categories) params.categories = '';
        if (!params.page) params.page = 1;
        if (!params.sort) params.sort = '';
        if (!params.term) params.term = '';
        if (!params.excludes) params.excludes = '';
        
        const token = localStorage.token ? localStorage.token : '';
        var url = `/api/products?perPage=${params.perPage}&categories=${params.categories}&page=${params.page}&sort=${params.sort}&title=${params.term}&token=${token}&excludes=${params.excludes}`;
		url+="&language="+language;
        return axios.get(url);
    }

    doGetSpecialProducts(params) {
        if (!params.perPage) params.perPage = '';
        if (!params.page) params.page = 1;
        if (!params.categories) params.categories = '';
        if (!params.sort) params.sort = '';

        const token = localStorage.token ? localStorage.token : '';
        var url = `/api/products/specials?perPage=${params.perPage}&page=${params.page}&token=${token}&sort=${params.sort}&categories=${params.categories}`;
		url+=`&language=${language}`

        return axios.get(url);
    }

    doGetAllProducts() {
    
        return axios.get(`/api/products/pwa?language=${language}`);
    }

    doGetProductById(id, token) {
        let url = `/api/products/${id}`;

        if (token) url += `?token=${token}`;

        return axios.get(url);
    }

    doGetLastSeenProducts(perPage = '') {
    	
        let url = `/api/activities/products/viewed?perPage=${perPage}&language=${language}`;
        if (localStorage.token) url += `&token=${localStorage.token}`;

        return axios.get(url);
    }

    doSendReview(product_id, review, rate) {

        const headers = {
                headers: {
                    'Authorization': `Bearer ${localStorage.token}`
                }
            },
            data = {
                'product_id': product_id,
                'rate': rate,
                'review': review
            };

        return axios.post(`/api/ratings`, data, headers);
    }

    doGetReviewsByProductId(product_id, params) {
        let url = `/api/ratings/product/${product_id}`;

        if (params.perPage) {
            url += `?perPage=${params.perPage}`
        }

        if (!params.page) params.page = 1;

        url += `&page=${params.page}`;

        return axios.get(url);
    }

    doGetCardsByProductId(product_id) {
        return axios.get(`/api/products/${product_id}/cards`);
    }

    doGetQuestionsByProductId(product_id, params) {
        let url = `/api/products/${product_id}/questions`;

        if (!params.page) params.page = 1;
        if (!params.search) params.search = '';
        if (!params.perPage) params.perPage = '';

        url += `?search=${params.search}&page=${params.page}&perPage=${params.perPage}`;

        return axios.get(url);
    }

    doCreateQuestion(product_id, question) {
        const headers = {
                headers: {
                    'Authorization': `Bearer ${localStorage.token}`
                }
            },
            data = {
                "product_id": product_id,
                "question": question
            };

        return axios.post(`/api/products/questions`, data, headers);
    }

    doRegisterView(product_id) {
        const data = {
            "product_id": product_id
        };

        return axios.post(`/api/activities/visit/page-product`, data);
    }

    doSearch(params) {
        if (!params.term) params.term = '';
        if (!params.perPage) params.perPage = '';
        if (!params.page) params.page = 1;

        return axios.get(`/api/search?term=${params.term}&perPage=${params.perPage}&page=${params.page}`);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/product-service.js